export * from './alarmApi.service';
import { AlarmApiService } from './alarmApi.service';
export * from './bookingApi.service';
import { BookingApiService } from './bookingApi.service';
export * from './breakApi.service';
import { BreakApiService } from './breakApi.service';
export * from './commandsApi.service';
import { CommandsApiService } from './commandsApi.service';
export * from './companyApi.service';
import { CompanyApiService } from './companyApi.service';
export * from './convApi.service';
import { ConvApiService } from './convApi.service';
export * from './deviceOperationApi.service';
import { DeviceOperationApiService } from './deviceOperationApi.service';
export * from './devicesApi.service';
import { DevicesApiService } from './devicesApi.service';
export * from './documentApi.service';
import { DocumentApiService } from './documentApi.service';
export * from './emptyZonesApi.service';
import { EmptyZonesApiService } from './emptyZonesApi.service';
export * from './gbfsApi.service';
import { GbfsApiService } from './gbfsApi.service';
export * from './hubApi.service';
import { HubApiService } from './hubApi.service';
export * from './institutionApi.service';
import { InstitutionApiService } from './institutionApi.service';
export * from './mapApi.service';
import { MapApiService } from './mapApi.service';
export * from './mdsApi.service';
import { MdsApiService } from './mdsApi.service';
export * from './modelApi.service';
import { ModelApiService } from './modelApi.service';
export * from './newsApi.service';
import { NewsApiService } from './newsApi.service';
export * from './paymentMethodApi.service';
import { PaymentMethodApiService } from './paymentMethodApi.service';
export * from './profileApi.service';
import { ProfileApiService } from './profileApi.service';
export * from './promotionApi.service';
import { PromotionApiService } from './promotionApi.service';
export * from './provider.service';
import { ProviderService } from './provider.service';
export * from './rateApi.service';
import { RateApiService } from './rateApi.service';
export * from './rentalApi.service';
import { RentalApiService } from './rentalApi.service';
export * from './reportApi.service';
import { ReportApiService } from './reportApi.service';
export * from './scheduledBookingApi.service';
import { ScheduledBookingApiService } from './scheduledBookingApi.service';
export * from './subscriptionApi.service';
import { SubscriptionApiService } from './subscriptionApi.service';
export * from './translationApi.service';
import { TranslationApiService } from './translationApi.service';
export * from './voucherApi.service';
import { VoucherApiService } from './voucherApi.service';
export * from './walletApi.service';
import { WalletApiService } from './walletApi.service';
export * from './webhookApi.service';
import { WebhookApiService } from './webhookApi.service';
export const APIS = [AlarmApiService, BookingApiService, BreakApiService, CommandsApiService, CompanyApiService, ConvApiService, DeviceOperationApiService, DevicesApiService, DocumentApiService, EmptyZonesApiService, GbfsApiService, HubApiService, InstitutionApiService, MapApiService, MdsApiService, ModelApiService, NewsApiService, PaymentMethodApiService, ProfileApiService, PromotionApiService, ProviderService, RateApiService, RentalApiService, ReportApiService, ScheduledBookingApiService, SubscriptionApiService, TranslationApiService, VoucherApiService, WalletApiService, WebhookApiService];
